export default function Loader(props) {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <div className="logo break-all tracking-tighter antialiased text-xl px-7 text-black-200">
        <h1 className="">Loading . . . </h1>
      </div>
    </div>
  );
}
